import React, { useEffect } from "react";
import JobsHireDetailsHero from "../components/jobsHireDetailsPage/JobsHireDetailsHero";
 
import Navbar from "../components/homepage/Navbar";
import { Header, Footer } from "../shared";

const JobsHireDetailsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <JobsHireDetailsHero />
      <Footer />
    </div>
  );
};

export default JobsHireDetailsPage;
